import { ApolloClient } from "apollo-client"
import { setContext } from "apollo-link-context"
import { createHttpLink } from "apollo-link-http"
import { InMemoryCache } from "apollo-cache-inmemory"

const csrfElement = document.head.querySelector("[name=csrf-token]")
const csrfToken = csrfElement != null ? csrfElement.content : ""

const privateHttpLink = new createHttpLink({
  uri: "/recruiter-insights/api/v1/graphql",
  credentials: "same-origin",
})

const publicHttpLink = new createHttpLink({
  uri: "/recruiter-insights/api/v1/public/graphql",
  credentials: "same-origin",
})

const x1HttpLink = new createHttpLink({
  uri: "/xing-one/api",
  credentials: "same-origin",
})

const cache = new InMemoryCache({
  addTypename: false,
})

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      "X-Requested-With": "XMLHttpRequest",
      "X-CSRF-Token": csrfToken,
    },
  }
})

const client = new ApolloClient({
  link: authLink.concat(privateHttpLink),
  cache,
})

const publicClient = new ApolloClient({
  link: authLink.concat(publicHttpLink),
  cache,
})

const x1Client = new ApolloClient({
  link: authLink.concat(x1HttpLink),
  cache,
})

export { client, publicClient, x1Client }
